(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vc-day-night-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vc-day-night')) {
  customElements.define('vc-day-night', class extends HTMLElement {
    connectedCallback() { this.startTimer = setTimeout(() => this.init(), 0); }
    init() {
      if (!this.isConnected) return;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.stage = this.querySelector('.dn-stage'); this.video = this.querySelector('video');
      this.poster = this.querySelector('.dn-poster'); this.playButton = this.querySelector('.dn-play');
      this.pins = [...this.querySelectorAll('.dn-pin')]; this.events = new AbortController();
      const opts = {signal:this.events.signal};
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.wantsPlay = !this.motion.matches; this.visible = false; this.generation = 0;
      this.video.muted = true; this.video.playsInline = true;
      this.setAttribute('data-js','');
      this.video.addEventListener('loadedmetadata', () => { if(this.video.videoWidth && this.video.videoHeight) this.ratio=this.video.videoWidth/this.video.videoHeight; this.layout(); }, opts);
      this.video.addEventListener('playing', () => { this.setAttribute('data-playing-frame',''); this.status(''); }, opts);
      for (const name of ['play','pause']) this.video.addEventListener(name, () => { this.playButton.textContent = this.video.paused ? 'Play video' : 'Pause video'; }, opts);
      this.video.addEventListener('error', () => { this.removeAttribute('data-playing-frame'); this.status('Video unavailable. Destination links are still available.'); this.setAttribute('data-cropped',''); }, opts);
      this.playButton.addEventListener('click', () => { this.wantsPlay = this.video.paused; this.sync(); }, opts);
      this.motion.addEventListener('change', () => { if (this.motion.matches) { this.wantsPlay=false; this.video.pause(); } }, opts);
      document.addEventListener('visibilitychange', () => { this.tick(); this.sync(); }, opts);
      window.addEventListener('pageshow', () => this.tick(), opts);
      window.addEventListener('resize', () => this.layout(), opts);
      document.addEventListener('click', e => { if (!this.contains(e.target)) this.closePins(); }, opts);
      this.addEventListener('click', e => { if (!e.target.closest('.dn-pin')) this.closePins(); }, opts);
      this.addEventListener('keydown', e => { if(e.key==='Escape') { const b=this.querySelector('.dn-pin.is-open button'); this.closePins(); b?.focus(); } }, opts);
      for(const pin of this.pins) {
        pin.querySelector('button').addEventListener('click', event => {
          const link=pin.querySelector('.dn-panel a');
          if(!window.Shopify?.designMode && event.detail>0 && matchMedia('(hover: hover) and (pointer: fine)').matches && link) { window.location.assign(link.href); return; }
          this.openPin(pin, !pin.classList.contains('is-open'));
        }, opts);
        pin.addEventListener('pointerenter', e => { if(e.pointerType==='mouse') this.openPin(pin,true); }, opts);
        pin.addEventListener('pointerleave', e => { if(e.pointerType==='mouse' && !pin.contains(document.activeElement)) this.openPin(pin,false); }, opts);
        pin.addEventListener('focusout', () => { queueMicrotask(() => { if(this.isConnected && !pin.contains(document.activeElement)) this.openPin(pin,false); }); }, opts);
      }
      this.addEventListener('shopify:block:select', e => { const pin=e.target.closest('.dn-pin'); if(pin) this.openPin(pin,true); }, opts);
      if ('ResizeObserver' in window) { this.resize = new ResizeObserver(() => this.layout()); this.resize.observe(this.stage); }
      if ('IntersectionObserver' in window) { this.observer = new IntersectionObserver(entries => { this.visible=entries[0].isIntersecting; this.sync(); }); this.observer.observe(this); }
      else this.visible=true;
      this.tick();
    }
    clock(date = new Date()) {
      if(this.dataset.zone==='visitor') return {hour:date.getHours(),minute:date.getMinutes(),second:date.getSeconds()};
      const parts = new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Kolkata',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(date);
      const get = key => Number(parts.find(p=>p.type===key).value);
      return {hour:get('hour'),minute:get('minute'),second:get('second')};
    }
    tick() {
      clearTimeout(this.clockTimer);
      if(!this.isConnected) return;
      const now=new Date(), c=this.clock(now);
      const scheduled=c.hour>=6 && c.hour<18 ? 'day':'night';
      const requested=['day','night'].includes(this.dataset.preview) ? this.dataset.preview : scheduled;
      const available = name => (this.config[name].sources || []).some(s=>s.format==='mp4' || s.mime_type==='video/mp4');
      const actual=available(requested) ? requested : available(requested==='day'?'night':'day') ? (requested==='day'?'night':'day') : requested;
      if(this.active!==actual) this.switchScene(actual);
      // Check at each boundary and at least every minute (also after tab wake).
      const seconds=c.hour*3600+c.minute*60+c.second;
      const next=seconds<21600 ? 21600 : seconds<64800 ? 64800 : 108000;
      const delay=Math.min(60000,Math.max(50,(next-seconds)*1000-now.getMilliseconds()));
      this.clockTimer=setTimeout(()=>this.tick(),delay);
    }
    switchScene(scene) {
      this.active=scene; this.generation++; this.closePins(); this.video.pause();
      this.removeAttribute('data-playing-frame'); this.dataset.scene=scene;
      const config=this.config[scene]; this.ratio=Number(config.ratio)||16/9;
      if(config.poster) { this.poster.src=config.poster; this.poster.hidden=false; this.video.poster=config.poster; }
      else { this.poster.hidden=true; this.poster.removeAttribute('src'); this.video.removeAttribute('poster'); }

      const sources=(config.sources||[]).filter(s=>s.format==='mp4'||s.mime_type==='video/mp4').sort((a,b)=>(b.height||0)-(a.height||0));
      const source=sources.find(s=>(s.height||0)<=1080)||sources[0];
      this.playButton.hidden=!source;
      if(source) { this.video.src=source.url; this.video.load(); this.sync(); }
      else { this.video.removeAttribute('src'); this.video.load(); this.status('Select a day or night video in the theme editor.'); }
      this.layout();
    }
    sync() {
      if(!this.video || !this.video.getAttribute('src')) return;
      if(this.wantsPlay && this.visible && !document.hidden) {
        const generation=this.generation;
        this.video.play()?.catch(error=>{
          if(error.name==='AbortError'||generation!==this.generation||!this.isConnected) return;
          this.wantsPlay=false; this.playButton.textContent='Play video';
        });
      } else this.video.pause();
    }
    closePins() { for(const pin of this.pins||[]) { pin.classList.remove('is-open'); pin.querySelector('button').setAttribute('aria-expanded','false'); pin.querySelector('.dn-panel').hidden=true; } }
    openPin(pin,open) {
      this.closePins(); if(!open) return;
      pin.classList.add('is-open'); pin.querySelector('button').setAttribute('aria-expanded','true'); pin.querySelector('.dn-panel').hidden=false;
      this.placePanel(pin);
    }
    placePanel(pin) {
      const panel=pin.querySelector('.dn-panel'); if(panel.hidden) return;
      const x=parseFloat(pin.style.left)||0, y=parseFloat(pin.style.top)||0;
      const half=panel.offsetWidth/2,w=this.stage.clientWidth;
      const shift=Math.max(0,half+10-x)-Math.max(0,x+half+10-w);
      panel.style.marginLeft=shift+'px';
      panel.style.bottom=y<panel.offsetHeight+48?'auto':'44px'; panel.style.top=y<panel.offsetHeight+48?'44px':'auto';
    }
    layout() {
      if(!this.stage) return;
      const w=this.stage.clientWidth,h=this.stage.clientHeight,r=this.ratio||16/9;
      const fit=getComputedStyle(this.video).objectFit;
      const scale=fit==='cover'?Math.max(w/r,h):Math.min(w/r,h);
      const rw=r*scale,rh=scale,ox=(w-rw)/2,oy=(h-rh)/2;
      let cropped=false;
      for(const pin of this.pins) {
        const x=ox+Number(pin.dataset.x)/100*rw,y=oy+Number(pin.dataset.y)/100*rh;
        pin.style.left=x+'px'; pin.style.top=y+'px';
        pin.hidden=x<22||x>w-22||y<22||y>h-70;
        if(pin.hidden) { cropped=true; pin.classList.remove('is-open'); pin.querySelector('button').setAttribute('aria-expanded','false'); pin.querySelector('.dn-panel').hidden=true; }
        else this.placePanel(pin);
      }
      this.toggleAttribute('data-cropped',cropped||Boolean(this.video.error)); this.setAttribute('data-ready','');
    }
    status(text) { this.querySelector('.dn-status').textContent=text; }
    disconnectedCallback() {
      clearTimeout(this.startTimer); clearTimeout(this.clockTimer); this.events?.abort(); this.resize?.disconnect(); this.observer?.disconnect(); this.video?.pause();

    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-premium-milestones"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vc-milestones')) {
  customElements.define('vc-milestones', class extends HTMLElement {
    connectedCallback() {
      this.frame = 0;
      this.start = () => {
        if (!this.isConnected || this.started) return;
        this.started = true;
        this.items = [...this.querySelectorAll('.vcm__item')];
        this.rail = this.querySelector('.vcm__rail');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.dataset.animate !== 'true' || reduced.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
          this.items.forEach(item => item.classList.add('is-seen'));
          return;
        }
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-seen');
              this.observer.unobserve(entry.target);
            }
          });
        }, {threshold: 0, rootMargin: '0px 0px -35px 0px'});
        this.items.forEach(item => {
          if (item.getBoundingClientRect().top < window.innerHeight - 35) item.classList.add('is-seen');
          else this.observer.observe(item);
        });
        this.update = () => {
          this.frame = 0;
          const rect = this.rail.getBoundingClientRect();
          const value = Math.max(0, Math.min(1, (window.innerHeight * .72 - rect.top) / Math.max(rect.height, 1)));
          this.style.setProperty('--vcm-progress', value);
        };
        this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(this.update); };
        this.update();
        this.classList.add('is-ready');
        window.addEventListener('scroll', this.schedule, {passive:true});
        window.addEventListener('resize', this.schedule);
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, {once:true});
      else this.start();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.start);
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      cancelAnimationFrame(this.frame);
      this.classList.remove('is-ready');
      this.started = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-premium-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vc-reviews')) {
  customElements.define('vc-reviews', class extends HTMLElement {
    connectedCallback() { this.timer = setTimeout(() => this.init(), 0); }
    init() {
      this.track = this.querySelector('.vcr__track');
      this.cards = [...this.querySelectorAll('[data-review]')];
      if (!this.track || !this.cards.length) return;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.prev.addEventListener('click', () => this.move(-1), opts);
      this.next.addEventListener('click', () => this.move(1), opts);
      this.track.addEventListener('scroll', () => this.update(), { ...opts, passive: true });
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.move(e.key === 'ArrowRight' ? 1 : -1); }
      }, opts);
      this.addEventListener('shopify:block:select', e => {
        const card = e.target.closest('[data-review]');
        if (card) this.scrollToCard(card);
      }, opts);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    scrollToCard(card) {
      const shift = card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollBy({ left: shift, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    move(direction) {
      const t = this.track.getBoundingClientRect();
      const positions = this.cards.map(c => c.getBoundingClientRect().left - t.left);
      let index;
      if (direction > 0) index = positions.findIndex(x => x > 5);
      else { index = -1; positions.forEach((x, i) => { if (x < -5) index = i; }); }
      if (index >= 0) this.scrollToCard(this.cards[index]);
    }
    update() {
      const t = this.track.getBoundingClientRect();
      const positions = this.cards.map(c => c.getBoundingClientRect());
      const visible = positions.map((r, i) => r.right > t.left + 8 && r.left < t.right - 8 ? i + 1 : null).filter(Boolean);
      this.querySelector('.vcr__nav').hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
      this.prev.disabled = positions[0].left >= t.left - 3;
      this.next.disabled = positions[positions.length - 1].right <= t.right + 3;
      const label = visible.length ? `${visible[0]}${visible.length > 1 ? '–' + visible[visible.length - 1] : ''} / ${this.cards.length}` : '';
      const counter = this.querySelector('.vcr__counter');
      if (counter.textContent !== label) counter.textContent = label;
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-video-shop-pins"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vc-shop-pins')) {
  customElements.define('vc-shop-pins', class extends HTMLElement {
    connectedCallback() { this.timer = setTimeout(() => this.init(), 0); }
    init() {
      if (!this.isConnected) return;
      this.video = this.querySelector('video');
      this.stage = this.querySelector('.vp-stage');
      this.button = this.querySelector('.vp-toggle');
      this.pins = [...this.querySelectorAll('.vp-pin-wrap')];
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.setAttribute('data-js', '');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.wantsPlay = !this.motion.matches;
      this.visible = false;
      const layout = () => this.layout();
      if ('ResizeObserver' in window) { this.resize = new ResizeObserver(layout); this.resize.observe(this.stage); }
      window.addEventListener('resize', layout, options);
      this.addEventListener('shopify:block:select', event => {
        const wrap = event.target.closest('.vp-pin-wrap');
        if (wrap) wrap.querySelector('a')?.focus({preventScroll: true});
      }, options);
      if (this.video && this.button) {
        this.video.muted = true; this.video.playsInline = true; this.video.controls = false;
        this.button.hidden = false;
        this.video.addEventListener('loadedmetadata', layout, options);
        const update = () => { this.button.textContent = this.video.paused ? 'Play video' : 'Pause video'; };
        this.video.addEventListener('play', update, options);
        this.video.addEventListener('pause', update, options);
        this.video.addEventListener('playing', () => { this.setAttribute('data-started', ''); this.querySelector('.vp-status').textContent = ''; }, options);
        this.video.addEventListener('error', () => { this.removeAttribute('data-started'); this.querySelector('.vp-status').textContent = 'Video unavailable. You can still use the shop links.'; }, options);
        this.button.addEventListener('click', () => { this.wantsPlay = this.video.paused; if (this.wantsPlay) this.play(); else this.video.pause(); }, options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) { this.wantsPlay = false; this.video.pause(); } }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
          this.observer.observe(this);
        } else { this.visible = true; this.sync(); }
      }
      this.layout();
    }
    layout() {
      const w = this.stage.clientWidth, h = this.stage.clientHeight;
      if (!w || !h) return;
      const ratio = this.video?.videoWidth ? this.video.videoWidth / this.video.videoHeight : Number(this.dataset.ratio) || 16 / 9;
      const media = this.video || this.querySelector('.vp-poster');
      const fit = media ? getComputedStyle(media).objectFit : 'contain';
      // Reproduce CSS object-fit with centered object-position.
      const scale = fit === 'cover' ? Math.max(w / ratio, h) : Math.min(w / ratio, h);
      const renderedWidth = ratio * scale, renderedHeight = scale;
      const offsetX = (w - renderedWidth) / 2, offsetY = (h - renderedHeight) / 2;
      let cropped = false;
      for (const pin of this.pins) {
        const x = offsetX + Number(pin.dataset.x) / 100 * renderedWidth;
        const y = offsetY + Number(pin.dataset.y) / 100 * renderedHeight;
        pin.style.left = x + 'px'; pin.style.top = y + 'px';
        // Hide pins when their anchor has been cropped; retain destination in the link list.
        pin.hidden = x < 24 || x > w - 24 || y < 24 || y > h - 80;
        if (pin.hidden) cropped = true;
        // Keep labels inside the screen near its left and right edges.
        const link = pin.querySelector('.vp-pin');
        const half = link.offsetWidth / 2;
        const shift = Math.max(0, half + 8 - x) - Math.max(0, x + half + 8 - w);
        pin.querySelector('.vp-label').style.transform = 'translateX(' + shift + 'px)';
      }
      this.toggleAttribute('data-cropped', cropped);
      this.setAttribute('data-ready', '');
    }
    play() {
      this.video.play()?.catch(error => {
        if (error.name === 'AbortError' || !this.isConnected) return;
        this.wantsPlay = false; this.button.textContent = 'Play video';
      });
    }
    sync() { if (this.wantsPlay && this.visible && !document.hidden) this.play(); else this.video?.pause(); }
    disconnectedCallback() {
      clearTimeout(this.timer); this.events?.abort(); this.resize?.disconnect(); this.observer?.disconnect(); this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vc-video-hero')) {
    customElements.define('vc-video-hero', class extends HTMLElement {
      connectedCallback() {
        // Defer until children exist, including dynamically inserted editor sections.
        this.initTimer = setTimeout(() => this.init(), 0);
      }
      init() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('.vc-hero__toggle');
        this.status = this.querySelector('.vc-hero__status');
        if (!this.video || !this.button || !this.isConnected) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.wantsPlay = !this.motion.matches;
        this.visible = true;
        this.video.muted = true;
        this.video.controls = false;
        this.video.playsInline = true;
        this.button.hidden = false;
        const update = () => { this.button.textContent = this.video.paused ? 'Play video' : 'Pause video'; };
        this.video.addEventListener('play', update, options);
        this.video.addEventListener('pause', update, options);
        this.video.addEventListener('playing', () => {
          this.setAttribute('data-started', ''); this.status.textContent = ''; update();
        }, options);
        this.video.addEventListener('error', () => {
          this.removeAttribute('data-started');
          this.status.textContent = 'Video unavailable. Please try again later.';
          update();
        }, options);
        this.button.addEventListener('click', () => {
          this.wantsPlay = this.video.paused;
          if (this.wantsPlay) this.play(); else this.video.pause();
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) { this.wantsPlay = false; this.video.pause(); }
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting; this.sync();
          }, { threshold: 0 });
          this.observer.observe(this);
        } else { this.sync(); }
      }
      play() {
        const promise = this.video.play();
        if (promise) promise.catch(error => {
          if (error.name === 'AbortError') return;
          this.wantsPlay = false;
          this.button.textContent = 'Play video';
          this.status.textContent = 'Press Play video to start playback.';
        });
      }
      sync() {
        if (this.wantsPlay && this.visible && !document.hidden) this.play();
        else this.video.pause();
      }
      disconnectedCallback() {
        clearTimeout(this.initTimer);
        if (this.events) this.events.abort();
        if (this.observer) this.observer.disconnect();
        if (this.video) this.video.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
